import React from "react"

const CaratUp = props => (
  <svg viewBox="0 0 28 28" {...props}>
    <path d="M.595 21.453a1.73 1.73 0 002.366-.199L14 10.449l11.035 10.805a1.724 1.724 0 002.369.199 1.678 1.678 0 00.2-2.365L15.285 6.767a1.681 1.681 0 00-2.566 0L.399 19.088a1.682 1.682 0 00.196 2.365z" />
  </svg>
)

export default CaratUp
